import React from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';
import classNames from 'classnames';

const WelcomePredictionScreen = ({ setScreenNumber, handleSkip }) => {
  return (
    <div
      className={styles.container}
      style={{
        backgroundImage: `url("${getImageFromS3(
          'images/lm-double-splash/violet-background.png'
        )}")`
      }}
    >
      <p className={styles.title}>Привіт!</p>
      <p className={styles.description}>
        Час зробити паузу та дізнатися більше...
      </p>
      <p className={classNames(styles.description, styles.secondDescription)}>
        Тут трішки магії для настрою дня:
      </p>
      <div className={styles.gifContainer}>
        <img
          src={getImageFromS3('/images/mpmb/circle.png')}
          alt="circle"
          className={styles.circle}
        />
        <div className={styles.gifWithShadowContainer}>
          <div className={styles.topShadow} />
          <img
            src={getImageFromS3('/images/mpmb/welcome-prediction.gif')}
            alt="circle"
            className={styles.gif}
          />
          <div className={styles.bottomShadow} />
        </div>
        <div className={styles.buttonContainer}>
          <p className={styles.buttonTitle}>
            <b>Дізнатися</b>, що на тебе чекає сьогодні
          </p>
          <div
            className={styles.startButton}
            onClick={() => setScreenNumber(12)}
          >
            <img src={getImageFromS3('/images/mpmb/button.png')} alt="button" />
            <p>Почати</p>
          </div>
          <button
            type="button"
            className={styles.skipButton}
            onClick={handleSkip}
          >
            Пропустити
          </button>
        </div>
      </div>
      <div className={styles.footerContainer}>
        <a href="https://www.pmiprivacy.com/ukraine/uk/consumer/">
          Політика конфіденційності
        </a>
        <button onClick={() => setScreenNumber(9)}>Умови використання</button>
        <button onClick={() => setScreenNumber(10)}>FAQ</button>
        <button onClick={() => setScreenNumber(11)}>
          Параметри застосування файлів cookie
        </button>
      </div>
    </div>
  );
};

export default WelcomePredictionScreen;
